// src/App.tsx
import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import AddTurno from "./pages/AddTurno";
import Empleados from "./pages/Empleados";
import Reportes from "./pages/Reportes";
import { Box, CssBaseline } from "@mui/material";
import TurnosFijos from "./pages/TurnosFijos";
import CalendarReservations from "./pages/CalendarReservations";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Wallet from "./pages/Wallet";
import { useAppSelector } from "./hooks/useAppStore";

const App: React.FC = () => {
  const { isAuthenticated } = useAppSelector(({ auth }) => auth);

  return (
    <Router>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          path="*"
          element={
            isAuthenticated ? <MainApp /> : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </Router>
  );
};

const MainApp = () => {
  // Función de ejemplo para cerrar sesión
  const handleLogout = () => {
    // Aquí puedes implementar la lógica de logout
    alert("Cerrar sesión");
  };

  return (
    <Box>
      {/* Header con el nombre del club, logo y botón de logout */}
      <Header
        clubName="Flobi Club"
        logoUrl="/isologo-nar1.svg"
        onLogout={handleLogout}
      />
      <div style={{ display: "flex", marginTop: "64px" }}>
        <Sidebar />
        <main style={{ flexGrow: 1, padding: "20px" }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/add-turno" element={<AddTurno />} />
            <Route path="/turnos-fijos" element={<TurnosFijos />} />
            <Route path="/reportes" element={<Reportes />} />
            <Route path="/empleados" element={<Empleados />} />
            <Route path="/flobipay" element={<Wallet />} />
            <Route path="/calendar" element={<CalendarReservations />} />
          </Routes>
        </main>
      </div>
    </Box>
  );
};

export default App;
